<template lang="pug">
  v-app#app
    router-view
    global-loader
    global-snackbar
</template>

<script>
import GlobalLoader from './components/GlobalLoader';
import GlobalSnackbar from './components/GlobalSnackbar';

export default {
  name: 'App',
  components: {
    GlobalLoader,
    GlobalSnackbar
  }
};
</script>

<style>
#app{
  font-family: 'Poppins';
}
.panel{
  padding-left: 75px;
  padding-right: 75px;
}
.main{
  padding-top: 10px;
}
.content{
  padding: 30px;
}
.font-60{
  font-size: 60px !important;
}
.font-24{
  font-size: 24px !important;
}
.font-20{
  font-size: 20px !important;
}
.font-16{
  font-size: 16px !important;
}
.font-14{
  font-size: 14px !important;
}
.plain{
  text-transform: none !important;
}
</style>